export default {
  SSN: '###-##-####',
  telePhone: '+1(###)-###-####',
  stateAbbrv: 'AA',
  EIN: '##-#######',
};
